import '../App.css';

export default function PhasePin({ phase, onSelect }) {
  const phaseColor = phase.phase === '2' ? '#06668d' : '#058359e1'; // blue for phase 2, green for phase 1/default
  const powerText = formatPowerFromW(phase.summary?.total_power);
  const phaseLabel = phase.displayName || phase.name;
  const pinDirection = phase.pinDirection || 'up';
  const clampPercent = (val, min = 6, max = 94) => {
    const num = Number.parseFloat(val);
    if (Number.isNaN(num)) return `${min}%`;
    return `${Math.min(Math.max(num, min), max)}%`;
  };
  const top = clampPercent(phase.position.top);
  const left = clampPercent(phase.position.left);

  return (
    <button
      className={`phase-pin phase-pin--${pinDirection}`}
      style={{
        top,
        left,
        background: phaseColor,
        borderColor: phaseColor,
      }}
      onClick={() => onSelect(phase)}
    >
      <span className="phase-pin__label">
        <span className="phase-pin__name">{phaseLabel}</span>
        {powerText ? <span className="phase-pin__power">{powerText}</span> : null}
      </span>
    </button>
  );
}

const formatPowerFromW = (value) => {
  if (value == null) return '';
  const num = Number(value) || 0;
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(2)} MW`;
  if (num >= 1_000) return `${(num / 1000).toFixed(2)} kW`;
  return `${num.toFixed(0)} W`;
};
